import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';

import { TranslocoModule } from '@ngneat/transloco';

import { ComponentsModule } from '@core/components/components.module';
import { SharedModule } from '@core/shared.module';

import { ConsigneeEffects } from '@consignee/state';

import { ConsigneeLookupDialogComponent } from './consignee-lookup-dialog/consignee-lookup-dialog.component';
import { ConsigneeLookupDialogGridComponent } from './consignee-lookup-dialog/grid/grid.component';
import { CustomerConsigneeLookupDialogComponent } from './customer-consignee-lookup-dialog/customer-consignee-lookup-dialog.component';
import { CustomerConsigneeLookupDialogGridComponent } from './customer-consignee-lookup-dialog/grid/grid.component';

@NgModule({
  declarations: [
    ConsigneeLookupDialogComponent,
    ConsigneeLookupDialogGridComponent,
    CustomerConsigneeLookupDialogComponent,
    CustomerConsigneeLookupDialogGridComponent,
  ],
  imports: [CommonModule, SharedModule, ComponentsModule, TranslocoModule, EffectsModule.forFeature([ConsigneeEffects])],
  exports: [ConsigneeLookupDialogComponent, CustomerConsigneeLookupDialogComponent],
})
export class ConsigneeModule {}
